module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightheavysnow@3-1c0ffa96a19e5d789bd8ca545755a1fb.png";